import { USER_LOGIN_FAIL, USER_LOGIN_REQUEST, USER_LOGIN_SUCCESS, USER_REGISTER_REQUEST } from "../constants/userConstants"
import {USER_REGISTER_SUCCESS, USER_REGISTER_FAIL, USER_UPDATE_REQUEST,USER_UPDATE_SUCCESS,USER_UPDATE_FAIL } from "../constants/userConstants";
import axios from "axios";

export const login = (email,password) => async (dispatch) => {
    try {
        dispatch({type: USER_LOGIN_REQUEST});

        const config  = {
            headers: {
                "Content-type":"application/json",
                "Access-Control-Allow-Origin": "*",
                //'Authorization': `Bearer ${data.token}`,
            },
        };

        const {data} = await axios.post(
            "https://notesphere-backend-hkk4.onrender.com/user/login",
            {
                email,
                password,
            },
            config
        );

        dispatch({type:USER_LOGIN_SUCCESS,payload:data});

        localStorage.setItem("userInfo",JSON.stringify(data));
        //axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
    } catch (error) {
        dispatch({type:USER_LOGIN_FAIL,
        payload:
            error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
}

export const logout = () => async (dispatch) => {
    localStorage.removeItem("userInfo");
    dispatch({type:"USER_LOGOUT"});
}

export const register = (name,email,password,pic) => async (dispatch) => {
    try {
        dispatch({type:USER_REGISTER_REQUEST});

        const config  = {
            headers: {
                "Content-type":"application/json",
                "Access-Control-Allow-Origin": "*",
                //'Authorization': `Bearer ${data.token}`,
            },
        };

        const {data} = await axios.post(
            "https://notesphere-backend-hkk4.onrender.com/user",
            {
                name,
                email,
                password,
                pic
            },
            config
        );

        dispatch({type:USER_REGISTER_SUCCESS,payload:data});

        dispatch({type:USER_LOGIN_SUCCESS,payload:data});

        localStorage.setItem("userInfo",JSON.stringify(data));
    } catch (error) {
        dispatch({type:USER_REGISTER_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
            });
    }
}

export const updateProfile = (user) => async (dispatch,getState) => {
    try {
        dispatch({type:USER_UPDATE_REQUEST});

        const {
            userLogin: {userInfo},
        } = getState();

        const config  = {
            headers: {
                "Content-type":"application/json",
                'Authorization': `Bearer ${userInfo.token}`,
                "Access-Control-Allow-Origin": "*",
            },
        };

        const {data} = await axios.post("https://notesphere-backend-hkk4.onrender.com/user/profile",user,config);

        dispatch({type:USER_UPDATE_SUCCESS,payload:data});

        dispatch({type:USER_LOGIN_SUCCESS,payload:data});

        localStorage.setItem("userInfo",JSON.stringify(data));

    } catch (error) {
        dispatch({type:USER_REGISTER_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
            });
    }
}
